/* ============
 * FileTypes State
 * ============
 *
 * The state of the FileTypes module.
 */

export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/file-types/state.js